import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import getUrls from '@/assets/js/getUrls.js'
import echarts from 'echarts'
import htmlToPdf from '@/utils/htmlToPdf'

import './scss/global.scss'

Vue.use(Vant)
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts ;
Vue.use(htmlToPdf)
//定义全局变量

localStorage.setItem('hqtoken',getUrls('token'));
window.token =localStorage.getItem('token')

window.addEventListener('beforeunload', e => {
  Browser.close();
  localStorage.setItem('state',JSON.stringify(store.state))
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if (history.scrollRestoration) {
  //   history.scrollRestoration = 'manual'
  // }
  next()
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
